export function getView(claim, charge_templates, insurance_payment_accounts) {
  return (
    insurance_payment_accounts.length === 0 &&
    charge_templates.some(
      charge_template => charge_template.is_included_in_insurance_claim
    ) &&
    claim.charges.length === 0
  )
}
